import { action, observable } from 'mobx';

class TranslationStore {

    // PROPERTIES

    @observable CurrentLanguage = undefined;
    @observable currentLanguageShort = undefined;
    @observable currentLanguageFull = undefined;

    @action getLanguage() {
        const selectedLang = window.localStorage.getItem('lang');
        this.CurrentLanguage = selectedLang;
        return selectedLang;
    }

    // SET PROPERTIES

    @action setLanguage(selectedLanguage) {
        window.localStorage.setItem('lang', selectedLanguage);
    }

    @action setCurrentLanguageShort(selectedLanguage) {
        if (selectedLanguage === 'en') {
            this.currentLanguageShort = 'EN';
        } else if (selectedLanguage === 'zh') {
            this.currentLanguageShort = 'CN';
        } else if (selectedLanguage === 'zh-Hant') {
            this.currentLanguageShort = 'CNH';
        } else if (selectedLanguage === 'th') {
            this.currentLanguageShort = 'TH';
        } else if (selectedLanguage === 'ja') {
            this.currentLanguageShort = 'JA';
        }
    }

    @action setCurrentLanguageFull(selectedLanguage) {
        if (selectedLanguage === 'en') {
            this.currentLanguageFull = 'English';
        } else if (selectedLanguage === 'zh') {
            this.currentLanguageFull = '简体中文';
        } else if (selectedLanguage === 'zh-Hant') {
            this.currentLanguageFull = '繁體中文';
        } else if (selectedLanguage === 'th') {
            this.currentLanguageFull = 'ไทย';
        } else if (selectedLanguage === 'ja') {
            this.currentLanguageFull = '日本';
        }
    }
}

export default new TranslationStore();